import type {
  ClientLogger,
  ClientLoggerMeta,
  ClientTraceMeta,
} from '@landsbankinn/client-logger';

export class ConsoleLoggerWithPrefix implements ClientLogger {
  constructor(private prefix: string) {}
  private getMessage(message: string) {
    const prefix = `[${this.prefix}]`;
    // Colorize the prefix in gray for less visual noise
    return `\x1b[90m${prefix}\x1b[0m ${message}`;
  }
  private log(
    consoleFunction: (message?: unknown, ...optionalParams: unknown[]) => void,
    messageOrError: string | Error,
    meta?: ClientLoggerMeta,
  ) {
    if (meta) {
      consoleFunction(this.getMessage(messageOrError.toString()), meta);
    } else {
      consoleFunction(this.getMessage(messageOrError.toString()));
    }
  }
  error(err: Error, meta?: ClientLoggerMeta) {
    this.log(console.error, err, meta);
  }
  message(message: string, meta?: ClientLoggerMeta) {
    this.info(message, meta);
  }
  warn(message: string, meta?: ClientLoggerMeta) {
    this.log(console.warn, message, meta);
  }
  info(message: string, meta?: ClientLoggerMeta) {
    this.log(console.info, message, meta);
  }
  trace(message: string, meta?: ClientLoggerMeta) {
    this.log(console.debug, message, meta);
  }
}

export class ConsoleLoggerService implements ClientLogger {
  private logger: ClientLogger;
  constructor(prefix: string) {
    this.logger = new ConsoleLoggerWithPrefix(prefix);
  }

  error(err: Error, meta?: ClientLoggerMeta) {
    this.logger.error(err, meta);
  }
  warn(message: string, meta?: ClientLoggerMeta) {
    this.logger.warn(message, meta);
  }
  message(message: string, meta?: ClientLoggerMeta) {
    this.logger.message(message, meta);
  }
  info(message: string, meta?: ClientLoggerMeta) {
    this.logger.info(message, meta);
  }
  trace(message: string, meta?: ClientTraceMeta) {
    this.logger.trace(message, meta);
  }
}

export const internal = new ConsoleLoggerWithPrefix('Internal');
